module.exports = __webpack_public_path__ + "img/car-buyers-guide-new.97e4760e.png";